import clsx from "clsx";
import type { FC } from "react";
import { useMemo } from "react";
import { useMatchMedia } from "../../hooks/useMatchMedia";
import { Icon } from "../Icon/Icon";
import classes from "./Message.module.scss";

export interface MessageProps {
	id: number;
	text: string;
	className?: string;
}

export interface MessageComponent extends FC<MessageProps> {}

export const Message: MessageComponent = ({ id, text, className }) => {
	const { isTablet, isMobile }: any = useMatchMedia();

	const wrapperClassName = useMemo(
		() => clsx(classes.wrapper, {}, className),
		[className]
	);

	const arrowClassName = useMemo(
		() =>
			clsx(
				classes.icon,
				{
					[classes.down]: id % 2 === 1,
					[classes.up]: id % 2 === 0,
					[classes.default]: id === 6,
				},
				className
			),
		[className, id]
	);

	const iconName = useMemo(
		() =>
			id === 6 ? "arrow_default" : id % 2 === 0 ? "arrow_up" : "arrow_down",
		[id]
	);

	const iconSize = useMemo(
		() => (id === 6 ? 80 : id % 2 === 0 ? 100 : 90),
		[id]
	);

	const arrowClass = useMemo(
		() =>
			id === 6 ? classes.close : id % 2 === 0 ? classes.left : classes.right,
		[id]
	);

	return (
		<>
			{!isTablet && !isMobile ? (
				<div className={wrapperClassName}>
					<div className={classes.content}>
						<div className={classes.text}>{text}</div>
					</div>
					<Icon className={arrowClassName} name={iconName} size={iconSize} />
				</div>
			) : (
				<div className={classes.mobile}>
					<div className={classes.wrapper}>
						<div className={classes.content}>
							<div className={classes.text}>{text}</div>
						</div>
						<div className={arrowClass} />
					</div>
				</div>
			)}
		</>
	);
};
